document.addEventListener("click", function (e) {

    const btn = e.target.closest(".size-chart-btn");

    if (btn) {
        const wrapper = btn.closest(".product-block");

        if (wrapper) {
            wrapper.querySelector(".size-chart-modal").classList.add("active");
        }

        return;
    }

    if (
        e.target.closest(".size-chart-close") ||
        e.target.classList.contains("size-chart-overlay")
    ) {
        document.querySelectorAll(".size-chart-modal").forEach(function(modal){
            modal.classList.remove("active");
        });
    }

});

document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
        document.querySelectorAll(".size-chart-modal").forEach(function(modal){
            modal.classList.remove("active");
        });
    }
});